import { Chip, Tooltip } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import PersonSearchOutlinedIcon from '@mui/icons-material/PersonSearchOutlined';

export const ResolutionChip = (props: {
  targetQueue: string;
  kind?: ResolutionChipKind;
  tooltipString?: string;
}) => {
  const targetQueue = props.targetQueue;
  const kind = props.kind ?? 'default';

  if (kind === 'tooltip')
    return (
      <Chip
        label={getLabel(targetQueue)}
        style={{ backgroundColor: '#ffffff' }}
        icon={getIcon(targetQueue)}
      />
    );

  return (
    <Tooltip title={props.tooltipString ?? ''}>
      <Chip
        label={getLabel(targetQueue)}
        color={getColor(targetQueue)}
        size="small"
        icon={getIcon(targetQueue)}
        variant="outlined"
      />
    </Tooltip>
  );
};

const getColor = (targetQueue: string) => {
  switch (targetQueue) {
    case 'egress':
      return 'success';
    case 'needs_attention_q':
    case 'manual_dispatch_q':
      return 'warning';
    case 'wip_q':
      return 'info';
    case 'cancelled_q':
      return 'error';
    default:
      return 'default';
  }
};

const getIcon = (targetQueue: string) => {
  switch (targetQueue) {
    case 'egress':
      return <CheckIcon />;
    case 'manual_dispatch_q':
      return <PersonSearchOutlinedIcon />;
    default:
      return <ErrorOutlineIcon />;
  }
};

export const getLabel = (targetQueue: string) => {
  switch (targetQueue) {
    case 'dispatched_q':
      return 'Dispatched';
    case 'egress':
      return 'Completed';
    case 'needs_attention_q':
      return 'Attention Needed';
    case 'wip_q':
      return 'Started';
    case 'cancelled_q':
      return 'Cancelled';
    case 'manual_dispatch_q':
      return 'Needs Dispatching';
    case 'input_q':
    case 'auto_dispatch_q':
    default:
      return 'Processing';
  }
};

type ResolutionChipKind = 'default' | 'tooltip';
